<template>
	<div
		:class="[
			'absolute top-[100%] left-0 w-full p-4',
			'invisible opacity-0 group-focus-within/item:visible group-hover/item:visible',
			'group-focus-within/item:opacity-100 group-hover/item:opacity-100 transition-opacity duration-500',
		]"
	>
		<div
			:class="[
				'container grid grid-cols-3 bg-purple-900 rounded px-4',
				{
					'pr-0': !!banner,
				},
			]"
		>
			<div class="col-span-2">
				<ul class="grid grid-cols-2 gap-2 px-4 py-8">
					<li
						v-for="subItem in items"
						:key="`subMenuItem-${subItem.to.url}`"
					>
						<AtomLink
							v-bind="subItem.to"
							:class="[
								'flex gap-8 py-4 px-4 border border-transparent rounded transition-colors',
								'duration-200 hover:bg-purple-800 hover:border-purple-700 hover:shadow-lg',
							]"
							@click="emit('navigate')"
						>
							<AtomFontAwesome
								v-if="subItem.icon"
								class="size-10"
								:icon="subItem.icon"
							/>
							<AtomImage
								v-else-if="subItem.image"
								class="size-14"
								v-bind="subItem.image"
								:width="35"
								:height="35"
							/>
							<span class="flex flex-col gap-2">
								<span class="text-nowrap flex items-center gap-3">
									{{ subItem.text }}
								</span>
								<span
									class="text-functional-size-sm text-gray-300 min-w-96"
								>
									{{ subItem.description }}
								</span>
							</span>
						</AtomLink>
					</li>
				</ul>
			</div>
			<div
				v-if="banner"
				class="relative rounded-r overflow-hidden"
			>
				<div class="absolute size-full">
					<AtomImage
						v-bind="banner.image"
						img-class="object-cover h-full"
					/>
				</div>
				<div class="absolute top-0 left-0 size-full bg-gradient-to-r from-purple-900 to-transparent" />
				<div class="relative left-0 bottom-0 size-full p-8 flex flex-col justify-center gap-12">
					<AtomTitle
						tag="h2"
						size="xl"
					>
						{{ banner.title }}
					</AtomTitle>
					<div>
						<AtomButton
							:variant="ButtonVariant.LightBorder"
							size="lg"
							:to="banner.to"
							:text="banner.buttonText"
							icon-right="fa-angle-right"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';
import type { SubMenuType } from '#base/core/types/MainMenuItemType';

defineProps<SubMenuType>();

const emit = defineEmits(['navigate']);
</script>
